<template>
  <div class="container">
    <div class="content">
      <div class="title">
        <van-icon class="close van-icon-arrow-left" @click="$parent.getCodeShow = false"></van-icon>
        <span>绑定码获取步骤</span>
      </div>
      <span class="text1">第一步：</span>
      <span class="text2" v-if="$store.state.gameType == 1">请打开龙之国物语App-点击「社区」图标</span>
      <span class="text2" v-if="$store.state.gameType == 2">请打开钢岚App-点击「社区」图标</span>
      <span class="text2" v-if="$store.state.gameType == 3">请打开第七史诗App-点击【活动】图标</span>
      <img class="img1" v-if="$store.state.gameType == 1" src="../../assets/img/lzg/getcode-1.png" alt="" />
      <img class="img1" v-if="$store.state.gameType == 2" src="../../assets/img/gl/getcode-1.png" alt="" />
      <img class="img1" v-if="$store.state.gameType == 3" src="../../assets/img/dqss/getcode-1.png" alt="" />
      <span class="text1">第二步：</span>
      <span class="text2" v-if="$store.state.gameType == 1">打开社区后-点击「我的」-再点击「绑定码」图标，即可获取社区绑定码</span>
      <span class="text2" v-if="$store.state.gameType == 2">打开社区后-点击「我的」-再点击「绑定码」图标，即可获取社区绑定码</span>
      <span class="text2" v-if="$store.state.gameType == 3">打开活动后-点击【游戏社区】图标</span>
      <img class="img2" v-if="$store.state.gameType == 1" src="../../assets/img/lzg/getcode-2.png" alt="" />
      <img class="img2" v-if="$store.state.gameType == 2" src="../../assets/img/gl/getcode-2.png" alt="" />
      <img class="img2" v-if="$store.state.gameType == 3" src="../../assets/img/dqss/getcode-2.png" alt="" />
      <span class="text1" v-if="$store.state.gameType == 3">第三步：</span>
      <span class="text2" v-if="$store.state.gameType == 3">打开社区后-点击【我的】-再点击【绑定码】图标，即可获取社区绑定码</span>
      <img class="img3" v-if="$store.state.gameType == 3" src="../../assets/img/dqss/getcode-3.png" alt="" />
      <span class="bottom">若以上步骤还不能解决您的问题，请联系客服</span>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {},
  created() { },
  mounted() { }
};
</script>
<style lang='scss' scoped>
.ipad .container {
  transform: translateX(-60%);
}

.container {
  margin-top: 0 !important;
  max-width: 8.5rem;
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: 999;
  display: flex;
  justify-content: center;
  background-color: #fff;

  .content {
    display: flex;
    flex-direction: column;
    padding: 0 0.2rem;
    padding-top: 1.5rem;
    box-sizing: border-box;
    position: relative;
    overflow-y: auto;

    .title {
      max-width: 8.5rem;
      width: 100%;
      height: 1.5rem;
      background-color: #18232c;
      display: flex;
      justify-content: center;
      align-items: center;
      position: fixed;
      top: 0;
      left: 0;

      span {
        font-size: 0.34rem;
        color: #fff;
      }

      .close {
        position: absolute;
        left: 0.2rem;
      }
    }

    .text1 {
      font-size: 0.3rem;
      font-weight: 550;
    }

    .text2 {
      font-size: 0.26rem;
    }

    .img1 {
      width: 80%;
    }

    .img2 {
      width: 50%;
    }

    .bottom {
      width: 100%;
      text-align: center;
      font-size: 0.26rem;
      margin: 0.2rem 0;
    }
  }
}
</style>